import React from "react";
import "./PrepareSuccess.scss";
import { Link } from "react-router-dom";

const PrepareSuccess = () => {
  return (
    <div>
      <div className="w-full bg-[#F7F7F7] min-max-xs:w-[430px] ">
        <div className="flex flex-col mx-auto text-center pt-[32px] w-[840px] min-max-xs:w-[376px] min-max-xss:w-[300px] min-max-md:w-[700px] min-max-sm:w-[500px]">
          <h3 className="prepare-exam-title w-full min-max-xs:text-4xl text-5xl max-sm:text-4xl leading-[60px] max-md:leading-[50px] ">
            Prepare for Exam Success with College Mentor
          </h3>
          <p className="prepare-exam-description lg:px-20">
            Personalized guidance, Tailored study plans, Realistic mock exams,
            and Insightful feedback for effective progress tracking and
            strategic planning.
          </p>
        </div>
        <div className="min-max-sm:ml-32 min-max-md:w-[700px] min-max-xs:ml-20 lg:w-[940px] min-max-xss:ml-12 sm:flex-col  mx-auto mt-12 justify-between justify-center pb-12 flex flex-col md:flex-row gap-6 md:gap-8  ">
          <div className="min-max-md:w-[200px] flex relative flex-col px-4 py-10 text-white rounded-xl aspect-[0.81] max-w-[286px] shadow-[10px_10px_34px_rgba(0,0,0,0.15)]">
            <img
              loading="lazy"
              src="https://cdncollegementor.blob.core.windows.net/exams/exam_landing/prepare-success/study-planner.webp"
              className="object-cover absolute inset-0 size-full rounded-xl"
              alt="Study Planner"
            />
            <div className="flex relative gap-3 ml-6">
              <div className="flex flex-col">
                <div className="w-[60px] h-[60px] bg-[#00B489] flex rounded-full justify-center align-middle self-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    className="my-auto"
                  >
                    <g clip-path="url(#clip0_856_393)">
                      <path
                        d="M23.7305 17.6953C20.3384 17.6953 17.5781 20.4556 17.5781 23.8477C17.5781 27.2397 20.3384 30 23.7305 30C27.1225 30 30 27.2397 30 23.8477C30 20.4556 27.1225 17.6953 23.7305 17.6953ZM25.4883 24.7266H23.7305C23.2447 24.7266 22.8516 24.3335 22.8516 23.8477V22.0898C22.8516 21.604 23.2447 21.2109 23.7305 21.2109C24.2163 21.2109 24.6094 21.604 24.6094 22.0898V22.9688H25.4883C25.9741 22.9688 26.3672 23.3619 26.3672 23.8477C26.3672 24.3335 25.9741 24.7266 25.4883 24.7266Z"
                        fill="white"
                      />
                      <path
                        d="M3.51562 22.0898H1.75781C0.786973 22.0898 0 22.8768 0 23.8477C0 24.8184 0.786973 25.6055 1.75781 25.6055H3.51562C4.48646 25.6055 5.27344 24.8184 5.27344 23.8477C5.27344 22.8768 4.48646 22.0898 3.51562 22.0898Z"
                        fill="white"
                      />
                      <path
                        d="M3.51562 13.3008H1.75781C0.786973 13.3008 0 14.0878 0 15.0586C0 16.0293 0.786973 16.8164 1.75781 16.8164H3.51562C4.48646 16.8164 5.27344 16.0293 5.27344 15.0586C5.27344 14.0878 4.48646 13.3008 3.51562 13.3008Z"
                        fill="white"
                      />
                      <path
                        d="M3.51562 4.39453H1.75781C0.786973 4.39453 0 5.1815 0 6.15234C0 7.12307 0.786973 7.91016 1.75781 7.91016H3.51562C4.48646 7.91016 5.27344 7.12307 5.27344 6.15234C5.27344 5.1815 4.48646 4.39453 3.51562 4.39453Z"
                        fill="white"
                      />
                      <path
                        d="M25.4883 0H6.15234C4.6984 0 3.51562 1.18277 3.51562 2.63672C5.45455 2.63672 7.03125 4.21342 7.03125 6.15234C7.03125 8.09127 5.45455 9.66797 3.51562 9.66797V11.543C5.45455 11.543 7.03125 13.1197 7.03125 15.0586C7.03125 16.9975 5.45455 18.5742 3.51562 18.5742V20.332C5.45455 20.332 7.03125 21.9087 7.03125 23.8477C7.03125 25.7866 5.45455 27.3633 3.51562 27.3633C3.51562 28.8172 4.6984 30 6.15234 30H18.82C17.0066 28.5492 15.8203 26.3453 15.8203 23.8477C15.8203 19.4858 19.3686 15.9375 23.7305 15.9375C25.356 15.9375 26.9841 16.4325 28.2422 17.2765V2.63672C28.2422 1.18277 26.9422 0 25.4883 0ZM15.5629 19.1956L12.0472 22.7112C11.8755 22.8829 11.6506 22.9688 11.4258 22.9688C11.201 22.9688 10.976 22.8829 10.8044 22.7112L8.79937 20.7062C8.45607 20.3629 8.45607 19.8067 8.79937 19.4634C9.14268 19.1201 9.69891 19.1201 10.0422 19.4634L11.4258 20.847L14.32 17.9528C14.6633 17.6095 15.2196 17.6095 15.5629 17.9528C15.9062 18.2961 15.9062 18.8523 15.5629 19.1956ZM15.5629 12.1644L12.0472 15.68C11.8755 15.8517 11.6507 15.9375 11.4258 15.9375C11.201 15.9375 10.9761 15.8517 10.8045 15.68L8.79943 13.675C8.45602 13.3317 8.45602 12.7755 8.79937 12.4322C9.14268 12.0889 9.69891 12.0889 10.0422 12.4322L11.4258 13.8158L14.32 10.9215C14.6633 10.5782 15.2196 10.5782 15.5629 10.9215C15.9062 11.2648 15.9062 11.8211 15.5629 12.1644ZM15.5629 5.01592L12.0472 8.53154C11.8755 8.70322 11.6507 8.78906 11.4258 8.78906C11.201 8.78906 10.9761 8.70322 10.8045 8.53154L8.79943 6.52652C8.45602 6.18322 8.45602 5.62705 8.79937 5.28375C9.14268 4.94045 9.69891 4.94045 10.0422 5.28375L11.4258 6.66732L14.32 3.77309C14.6633 3.42979 15.2196 3.42979 15.5629 3.77309C15.9062 4.11639 15.9062 4.67262 15.5629 5.01592ZM23.7305 14.1797H18.457C17.9712 14.1797 17.5781 13.7866 17.5781 13.3008C17.5781 12.815 17.9712 12.4219 18.457 12.4219H23.7305C24.2163 12.4219 24.6094 12.815 24.6094 13.3008C24.6094 13.7866 24.2163 14.1797 23.7305 14.1797ZM23.7305 7.03125H18.457C17.9712 7.03125 17.5781 6.63814 17.5781 6.15234C17.5781 5.66654 17.9712 5.27344 18.457 5.27344H23.7305C24.2163 5.27344 24.6094 5.66654 24.6094 6.15234C24.6094 6.63814 24.2163 7.03125 23.7305 7.03125Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_856_393">
                        <rect width="30" height="30" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <h3 className="self-center mt-4 text-2xl font-bold text-center">
                  Study Planner
                </h3>
                <p className="mt-3 text-base text-center">
                  Build concepts step by step
                </p>
              </div>
            </div>
            <div className="flex relative gap-3 mt-4 text-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="10"
                viewBox="0 0 14 10"
                fill="none"
                className="mt-2"
              >
                <path
                  d="M5.51212 10L0.5 4.6141L1.77347 3.50021L5.44329 7.44264L11.6816 0L13.011 1.04714L5.51212 10Z"
                  fill="#00CC99"
                />
              </svg>
              <p>Choose Study Planner for targeted exam preparation.</p>
            </div>
            <div className="flex relative gap-3 mt-4 text-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="10"
                viewBox="0 0 14 10"
                fill="none"
                className="mt-2"
              >
                <path
                  d="M5.51212 10L0.5 4.6141L1.77347 3.50021L5.44329 7.44264L11.6816 0L13.011 1.04714L5.51212 10Z"
                  fill="#00CC99"
                />
              </svg>
              <div>Achieve daily goals with tailored schedules.</div>
            </div>
            <div className="flex relative gap-3 mt-4 text-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="10"
                viewBox="0 0 14 10"
                fill="none"
                className="mt-2"
              >
                <path
                  d="M5.51212 10L0.5 4.6141L1.77347 3.50021L5.44329 7.44264L11.6816 0L13.011 1.04714L5.51212 10Z"
                  fill="#00CC99"
                />
              </svg>
              <p>Ensuring focused progress </p>
            </div>
          </div>
          <div className="min-max-md:w-[200px] flex relative flex-col px-4 py-10 text-white rounded-xl aspect-[0.81] max-w-[286px] shadow-[10px_10px_34px_rgba(0,0,0,0.15)]">
            <img
              loading="lazy"
              src="https://cdncollegementor.blob.core.windows.net/exams/exam_landing/prepare-success/test-generator.webp"
              className="object-cover absolute inset-0 size-full rounded-xl"
              alt="Test Generator"
            />
            <div className="flex relative gap-3 ml-6">
              <div className="flex flex-col">
                <div className="w-[60px] h-[60px] bg-[#FF66CC] flex rounded-full justify-center align-middle self-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    className="my-auto"
                  >
                    <g clip-path="url(#clip0_856_411)">
                      <path
                        d="M29.334 12.3899L25.8928 11.5436C25.686 10.8913 25.4199 10.2587 25.0989 9.65361C25.6155 8.79357 26.7013 6.98344 26.7013 6.98344C26.9091 6.63756 26.8541 6.19465 26.5692 5.90971L24.0835 3.42404C23.7986 3.13822 23.3565 3.08332 23.0098 3.29186L20.3353 4.89434C19.7336 4.57588 19.1044 4.31238 18.4564 4.10725L17.6102 0.666094C17.5123 0.274687 17.1612 0 16.7578 0H13.2422C12.8388 0 12.4869 0.274687 12.3899 0.666035C12.3899 0.666035 11.8037 3.06779 11.5444 4.10637C10.8535 4.32521 10.1858 4.60934 9.54973 4.95609L6.77654 3.29186C6.42979 3.08584 5.98863 3.1391 5.70281 3.42404L3.21715 5.90971C2.93221 6.19465 2.87725 6.63756 3.08496 6.98344L4.79988 9.84762C4.5235 10.3927 4.29176 10.96 4.10725 11.541L0.666094 12.3899C0.274687 12.4877 0 12.8388 0 13.2422V16.7578C0 17.1612 0.274687 17.5131 0.666035 17.6101L4.10807 18.4564C4.31666 19.1181 4.58783 19.761 4.9166 20.3781L3.38197 22.9359C3.17426 23.2818 3.22922 23.7247 3.51416 24.0096L5.99982 26.4953C6.28395 26.7794 6.7268 26.8334 7.07355 26.6275C7.07355 26.6275 8.79445 25.5958 9.63732 25.0911C10.2476 25.4164 10.8861 25.685 11.5445 25.8936L12.3899 29.3339C12.4869 29.7254 12.8388 30 13.2422 30H16.7578C17.1612 30 17.5123 29.7253 17.6101 29.334L18.4556 25.8936C19.1328 25.6791 19.7851 25.4018 20.4056 25.0654C21.2716 25.5846 23.0097 26.6275 23.0097 26.6275C23.3556 26.8343 23.7985 26.7811 24.0834 26.4953L26.5691 24.0096C26.854 23.7247 26.909 23.2818 26.7013 22.9359L25.1211 20.3034C25.4327 19.712 25.6911 19.0932 25.8928 18.4564L29.3339 17.6101C29.7254 17.5123 30 17.1612 30 16.7578V13.2422C30 12.8388 29.7254 12.4877 29.334 12.3899ZM15 21.1523C11.6079 21.1523 8.84766 18.392 8.84766 15C8.84766 11.6079 11.6079 8.84766 15 8.84766C18.392 8.84766 21.1523 11.6079 21.1523 15C21.1523 18.392 18.392 21.1523 15 21.1523Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_856_411">
                        <rect width="30" height="30" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <h3 className="self-center mt-11 min-max-xs:mt-9 text-2xl font-bold text-center">
                  Test Generator
                </h3>
                <p className="mt-3 text-base text-center">
                  Make it short, make it long
                </p>
              </div>
            </div>
            <div className="flex relative gap-3 mt-5 text-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="10"
                viewBox="0 0 14 10"
                fill="none"
                className="mt-2"
              >
                <path
                  d="M5.51212 10L0.5 4.6141L1.77347 3.50021L5.44329 7.44264L11.6816 0L13.011 1.04714L5.51212 10Z"
                  fill="#FF66CC"
                />
              </svg>
              <p> Keep it timed, keep it relaxed</p>
            </div>
            <div className="flex relative gap-3 mt-5 text-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="10"
                viewBox="0 0 14 10"
                fill="none"
                className="mt-2"
              >
                <path
                  d="M5.51212 10L0.5 4.6141L1.77347 3.50021L5.44329 7.44264L11.6816 0L13.011 1.04714L5.51212 10Z"
                  fill="#FF66CC"
                />
              </svg>
              <p> Make it tough, make it easy</p>
            </div>
            <div className="flex relative gap-3 mt-5 text-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="10"
                viewBox="0 0 14 10"
                fill="none"
                className="mt-2"
              >
                <path
                  d="M5.51212 10L0.5 4.6141L1.77347 3.50021L5.44329 7.44264L11.6816 0L13.011 1.04714L5.51212 10Z"
                  fill="#FF66CC"
                />
              </svg>
              <p>Make it tough, make it easy</p>
            </div>
          </div>
          <div className="min-max-md:w-[200px] flex relative flex-col px-4 py-10 text-white rounded-xl aspect-[0.81] max-w-[286px] shadow-[10px_10px_34px_rgba(0,0,0,0.15)]">
            <img
              loading="lazy"
              src="https://cdncollegementor.blob.core.windows.net/exams/exam_landing/prepare-success/challange-zone.webp"
              className="object-cover absolute inset-0 size-full rounded-xl"
              alt="Challenge Gone"
            />
            <div className="flex relative gap-3 ml-6">
              <div className="flex flex-col">
                <div className="w-[60px] h-[60px] bg-[#FFD540] flex rounded-full justify-center align-middle self-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    className="my-auto"
                  >
                    <g clip-path="url(#clip0_856_371)">
                      <path
                        d="M29.0161 10.328C28.4981 9.39555 27.3223 9.05957 26.3899 9.5776L23.3257 11.2799L21.3059 8.19086C21.2462 8.19297 21.1865 8.19543 21.1263 8.19543C19.0919 8.19543 17.3397 6.96778 16.5689 5.21489C14.2005 5.21471 10.2037 5.21448 10.2037 5.21448C9.49971 5.21448 8.85154 5.5975 8.51193 6.21409L6.06564 10.6561C5.55113 11.5904 5.89139 12.7649 6.82566 13.2794C7.12109 13.4422 7.44055 13.5194 7.75561 13.5194C8.43676 13.5194 9.09723 13.1583 9.44902 12.5194L11.3448 9.07704H14.9923L9.42342 18.7979H2.67154C1.60496 18.7979 0.740234 19.6626 0.740234 20.7292C0.740234 21.7958 1.6049 22.6605 2.67154 22.6605H10.5255C11.2085 22.6605 11.8408 22.2998 12.1882 21.7117L13.5755 19.364L17.078 22.1236L14.9781 27.3479C14.5803 28.3375 15.0601 29.4623 16.0497 29.8601C16.2859 29.955 16.5296 29.9999 16.7694 29.9999C17.5347 29.9999 18.2591 29.542 18.562 28.7884L21.2014 22.222C21.5212 21.4264 21.2782 20.5153 20.6047 19.9847L16.7212 16.9249L19.4063 12.3437L21.0763 14.8978C21.445 15.4617 22.0617 15.7724 22.6941 15.7724C23.0122 15.7724 23.3343 15.6937 23.6306 15.5291L28.2658 12.9541C29.1981 12.4362 29.5341 11.2604 29.0161 10.328Z"
                        fill="white"
                      />
                      <path
                        d="M21.1261 6.4377C22.9038 6.4377 24.3449 4.99657 24.3449 3.21885C24.3449 1.44113 22.9038 0 21.1261 0C19.3484 0 17.9072 1.44113 17.9072 3.21885C17.9072 4.99657 19.3484 6.4377 21.1261 6.4377Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_856_371">
                        <rect width="30" height="30" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <h3 className="self-center mt-11 min-max-xs:mt-9 text-2xl font-bold text-center">
                  Challenge Zone
                </h3>
                <p className="mt-3 text-base text-center">
                  Beat Self, Beat Competitors
                </p>
              </div>
            </div>
            <div className="flex relative gap-3 mt-5 text-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="10"
                viewBox="0 0 14 10"
                fill="none"
                className="mt-2"
              >
                <path
                  d="M5.51212 10L0.5 4.6141L1.77347 3.50021L5.44329 7.44264L11.6816 0L13.011 1.04714L5.51212 10Z"
                  fill="#00CC99"
                />
              </svg>
              <p>Choose & challenge friends </p>
            </div>
            <div className="flex relative gap-3 mt-5 text-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="10"
                viewBox="0 0 14 10"
                fill="none"
                className="mt-2"
              >
                <path
                  d="M5.51212 10L0.5 4.6141L1.77347 3.50021L5.44329 7.44264L11.6816 0L13.011 1.04714L5.51212 10Z"
                  fill="#00CC99"
                />
              </svg>
              <p>Compete in real time</p>
            </div>
            <div className="flex relative gap-3 mt-5 text-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="10"
                viewBox="0 0 14 10"
                fill="none"
                className="mt-2"
              >
                <path
                  d="M5.51212 10L0.5 4.6141L1.77347 3.50021L5.44329 7.44264L11.6816 0L13.011 1.04714L5.51212 10Z"
                  fill="#00CC99"
                />
              </svg>
              <p>Share scores and certificates</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrepareSuccess;
